import { useContext } from 'react';
import { PictureContext } from './PictureContext';

export const usePictureContext = () => {
  const pictureContext = useContext(PictureContext);
  if (!pictureContext) {
    throw new Error('Picture Context not found');
  }
  return pictureContext;
};
